import React from 'react'
import { Link } from 'react-router-dom'
import TabLinkUI from '../../../widgets/output/TabLinkUI'
import ButtonUI from '../../../widgets/action/ButtonUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'

const BankAccountMonthHeaderUI = ({ context, account, bankAccountList, bankAccountNumber, onRefreshClick,
  onTransferClick, onAddCollectionAccClick, loanBankAccountNum, genBankAccountNum, onAddBankAccountClick
}) =>
  <div className='bank_hdr'>
    <LRTableActionsUI location='top'
      left={
        <span className='g_flex_left g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
          {/*<IconButtonUI icon='icon-plus' onClick={onAddBankAccountClick} label='Add Traditional Escrow' />*/}
          {
            bankAccountList.map((bankAccount, i) =>
              <TabLinkUI label={bankAccount.bankAccountNumber} key={i}
                active={bankAccount.bankAccountNumber === bankAccountNumber}
                to={`/su/accounts/${account.accountId}/bankAccounts/${bankAccount.bankAccountNumber}`}
              />
            )
          }
        </span>
      }
      right={
        <span className='g_flex_v g_text_right'>
          {
            onTransferClick && genBankAccountNum && context.permissions.includes('su_finance') &&
            <span><ButtonUI label='Transfer to Clime' onClick={onTransferClick} /></span>
          }
          {
            account.escrowAccountNumber === null && context.permissions.includes('su_superuser_business') &&
            <span><Link to='#' onClick={onAddCollectionAccClick}>Add Collection Account</Link></span>
          }
        </span>
      }
    />

    <table className='g_m_top_50'>
      <tbody>
        <tr className='g_muted g_small'>
          <td align='center'>Bank A/C no</td><td></td>
          <td align='center'>IFSC code</td><td></td>
          <td align='center'>Balance</td><td></td>
          <td align='center'>Pending</td><td></td>
          <td align='center'>Available</td>
        </tr>
        {
          bankAccountList.map((bankAccount, i) =>
            <tr key={i}>
              <td>{bankAccount.bankAccountNumber}</td><td></td>
              <td>{bankAccount.ifscCode}</td><td></td>
              <td align='right'>
                {bankAccount.currentBalance >= 0 ? bankAccount.currentBalanceF1 : `(${bankAccount.currentBalanceF1})`}
              </td><td></td>
              <td align='right'>
                {bankAccount.pendingBalance >= 0 ? bankAccount.pendingBalanceF1 : `(${bankAccount.pendingBalanceF1})`}
              </td><td></td>
              <td align='right'>
                {bankAccount.availableBalance >= 0 ? bankAccount.availableBalanceF1 : `(${bankAccount.availableBalanceF1})`}
              </td>
            </tr>
          )
        }
      </tbody>
    </table>

  </div>

export default BankAccountMonthHeaderUI
